import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const cseFormField = {
  gap: css`var(--cse-form-field-gap, ${csSpacing.spacing02})`,
  helpTextColor: css`var(--cse-form-field-help-text-color, ${csColorText.muted})`,
  invalidTextColor: css`var(--cse-form-field-invalid-text-color, ${csColorFunctional.error})`,
}

export const style: CSSResult = css`
  .cse-form-field {
    display: flex;
    flex-direction: column;
    position: relative;
    row-gap: ${cseFormField.gap};
  }

  .help-text {
    --cse-text-color: ${cseFormField.helpTextColor};
  }
  
  .invalid-text {
    --cse-text-color: ${cseFormField.invalidTextColor};
  }
`
